<div class="container ion-padding-vertical" [formGroup]="form">
  <div class="modal">
    <div class="modal-header">
      <h1 class="ion-text-center">Production Area Override</h1>
    </div>

    <div class="modal-content">
      <div class="production-area-modal__form">
        <div>
          <ion-label class="production-area-modal__no-sync-tooltip">This change will not sync back to the Core
            Application. It is
            specific for Point of Sale</ion-label>
        </div>
        <ion-list lines="none">
          <ion-radio-group formControlName="selectedArea">
            <ion-item *ngFor="let area of productionAreas">
              <ion-radio slot="start" [value]="area.id"></ion-radio>
              <div class="production-area-modal__item-text">
                <ion-label>{{ area.name }}</ion-label>

                <ion-label *ngIf="originalProductionAreaId === area.id"
                           class="production-area-modal__item-text__original_text">Original</ion-label>
              </div>
            </ion-item>
            <ion-item *ngIf="productionAreas?.length === 0">
              <ion-label>No production areas available</ion-label>
            </ion-item>
          </ion-radio-group>
        </ion-list>
      </div>
    </div>

    <div class="modal-footer">
      <div class="production-area-modal__actions">
        <ion-button color="clear" (click)="cancel()">Cancel</ion-button>
        <ion-button color="dark" (click)="save()">OK</ion-button>
      </div>
    </div>
  </div>
</div>
